// actions associated with authentication
export enum AuthActions {
    REGISTER = '[AUTH] register',
    LOGIN = '[AUTH] login',
    LOGOUT = '[AUTH] logout',
}